import { useEffect, useState } from "react";
import { getQuestionFolders, getSubjects } from "../../services/questionService";

const listOf = (res) => (Array.isArray(res) ? res : res?.results || []);

// Subjects and folders for the passage forms and filters, shared by every form: the last load is shown at
// once and refreshed on every mount, since folders can be created or renamed meanwhile (an old backend
// without folders just gives no folders).
let loaded = null;
let loading = null;

const load = () => {
  if (!loading) {
    loading = Promise.all([
      getSubjects({ params: { page: 1, page_size: 500 } }).then(listOf),
      getQuestionFolders().then(listOf).catch(() => []),
    ])
      .then(([subjects, folders]) => {
        loaded = { subjects, folders };
        return loaded;
      })
      .finally(() => {
        loading = null;
      });
  }
  return loading;
};

// `fresh`: the lists were loaded during this mount (until then they may be the cached ones, or empty).
export default function useBankLists(enabled = true) {
  const [lists, setLists] = useState(loaded || { subjects: [], folders: [] });
  const [fresh, setFresh] = useState(false);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    load()
      .then((data) => {
        if (!active) return;
        setLists(data);
        setFresh(true);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [enabled]);
  return { ...lists, fresh };
}
